// Must byte-match the server tool NAME (list_datasets.py) — the name is the
// single contract between server advertisement and browser dispatch.
export const LIST_DATASETS_TOOL_NAME = "list_datasets";

export const LIST_DATASETS_DEFAULT_LIMIT = 20;
export const LIST_DATASETS_MAX_LIMIT = 50;
